enum DeviceLightSensibilityEnum {
    VERY_LOW = 'VERY_LOW',
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
    VERY_HIGH = 'VERY_HIGH',
}

export default DeviceLightSensibilityEnum;
